import styled from "styled-components";

const TextWrapper = styled.div`
    flex: 1;
`;

export default TextWrapper;